import Marionette from 'backbone.marionette';

import MenuLayoutView from '../views/layout';

import Menu from '../models/menu';

module.exports = function (options) {
  var regions = new Marionette.RegionManager({
    regions: {
      view: '#layout-hook'
    }
  });

  var model = new Menu(options.initialData, this.options);

  var layout = new MenuLayoutView({
    model
  });
  regions.get('view').show(layout);
};



// WEBPACK FOOTER //
// ./menupicker/initializers/menupicker.js